// @flow
import {createActions, type ActionType, handleActions, type ReduxReducer} from 'redux-actions';
import {type AxiosPromise} from 'axios';
import {FULFILLED} from 'redux-promise-middleware';

import {ENDPOINTS} from 'constants/endpoints';
import {type ApplePayTotalsType} from 'reducers/applePayTotals/applePayTotalsType';
import {instanceGusaBackend} from 'libs/api';

export const defaultState = {
    shipping: 0,
    shippingDiscount: 0,
    shippingTax: 0,
    taxTotal: 0,
    subTotal: 0,
    grandTotal: 0,
    discount: 0,
    copay: 0,
};

export const {
    applepay: {getShippingMethodsAndTotalsApplePay},
} = createActions({
    APPLEPAY: {
        /**
         * Get shipping methods and totals for apple pay
         * @field {{country: string, postalCode: string, city: string, region: string}} address - address
         * @param {string} method - method
         * @return {AxiosPromise} Axios promise
         */
        GET_SHIPPING_METHODS_AND_TOTALS_APPLE_PAY: (
            {
                country,
                postalCode: postcode,
                city,
                region,
            }: {country: string, postalCode: string, city: string, region: string} = {},
            method: string,
        ): AxiosPromise =>
            instanceGusaBackend({
                method: 'get',
                url: ENDPOINTS.GET_PAYMENT_DATA,
                params: {
                    country: country ? country.toUpperCase() : country,
                    postcode,
                    city,
                    region: region ? region.toUpperCase() : region,
                    method,
                    collectTax: 1,
                },
                headers: {
                    'Content-Type': 'application/json',
                },
            }),
    },
});

export const applePayTotals: ReduxReducer<ApplePayTotalsType, AxiosPromise> = handleActions(
    {
        /**
         * Set apple pay totals
         * @param {ApplePayTotalsType} state - Current state
         * @param {ActionType<AxiosPromise>} action - Current action
         * @return {ApplePayTotalsType} New state
         */
        [`${getShippingMethodsAndTotalsApplePay}_${FULFILLED}`]: (
            state: ApplePayTotalsType,
            action: ActionType<AxiosPromise>,
        ): ApplePayTotalsType => {
            const {shippingMethods, ...result} = action.payload.data;
            return result;
        },
    },
    defaultState,
);
